/** An ISO time as "Oct 25, 2026, 09:14" (fr: "25 oct. 2026, 09 h 14"), in the reader's time zone; '—' when missing */
export const dateTime = (iso: string | undefined, language: string) => {
  if (!iso) return '—';
  const date = new Date(iso);
  if (isNaN(date.getTime())) return iso;
  return new Intl.DateTimeFormat(
    language.startsWith('fr') ? 'fr-CA' : 'en-CA',
    {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    }
  ).format(date);
};
